import script from "./RegistrationReports.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationReports.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationReports.vue?vue&type=style&index=0&id=734b08c8&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-734b08c8"]])

export default __exports__